import { ETH } from '../constants/assets'
import type { ChainConfig } from '../types'
import { getQuickNodeRpcUrl } from '../utils/getQuickNodeRpcUrl'

export const WORLDCHAIN = {
  name: 'worldchain',
  chainId: 480,
  averageBlockTimeSeconds: 2,
  explorerUrl: 'https://worldscan.org',
  nativeAsset: ETH,
  slip44: 60,
  wrappedNativeAsset: '0x4200000000000000000000000000000000000006',
  blockscoutApiUrl: 'https://worldchain-mainnet.explorer.alchemy.com/api',
  etherscanSupported: true,
  publicRpcUrls: [
    'https://worldchain-mainnet.g.alchemy.com/public',
    'https://worldchain.drpc.org',
    'https://sparkling-autumn-dinghy.worldchain-mainnet.quiknode.pro',
  ],
  getPrivateRpcUrls: () => {
    const worldchain: string[] = []
    process.env.ROUTEME_API_KEY && worldchain.push(`https://lb.routeme.sh/rpc/480/${process.env.ROUTEME_API_KEY}`)
    const quickNodeUrl = getQuickNodeRpcUrl('worldchain')
    quickNodeUrl && worldchain.push(quickNodeUrl)
    process.env.ALCHEMY_API_KEY &&
      worldchain.push(`https://worldchain-mainnet.g.alchemy.com/v2/${process.env.ALCHEMY_API_KEY}`)
    return worldchain
  },
} as const satisfies ChainConfig
